import React from 'react';
import Card from "../ui/Card";
import {countryCodes} from "../../utils/countryCodes";

const GolfersList = ({ title, tier="A", golfers }) => {

  const getCountryCode = (name) => {
    return countryCodes[name]?.toLowerCase() || "Not found";
  };

  const getTierPrice = (player) => {
    const prices = {
      'A': 250,
      'TIER_A': 250,
      'B': 200,
      'TIER_B': 200,
      'C': 150,
      'TIER_C': 150,
      'D': 100,
      'TIER_D': 100
    };
    // Use player's tier (which now comes from tournament)
    return prices[player.tier] || 100;
  };

  const handleBuyPlayer = (playerName, price) => {
    console.log(`Buying player: ${playerName} for $${price}`);
    // TODO: integrate buy action
  };

  return (
    <Card className="golfers-card">
      <div style={{ marginBottom: "var(--spacing-sm)" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "var(--spacing-sm)",
          }}
        >
          {title && <h2 className={`proskins-section-title tier_${tier.toLowerCase()}-text`}>{title}</h2>}
        </div>
      </div>

      <div className="proskins-table">
        {/* Header table */}
        <table className="proskins-table-head">
          <colgroup>
            <col style={{width: "15%"}}/>
            {/* Rank */}
            <col style={{width: "65%"}}/>
            {/* Name */}
            <col style={{width: "20%"}}/>
            {/* Action */}
          </colgroup>
          <thead>
          <tr>
            <th>Rank</th>
            <th>Name</th>
            <th>Action</th>
          </tr>
          </thead>
        </table>

        {/* Body table (scrollable) */}
        <div className="proskins-table-body">
          <table>
            <colgroup>
              <col style={{width: "13%"}}/>
              <col style={{width: "55%"}}/>
              <col style={{width: "25%"}}/>
            </colgroup>
            <tbody>
            {golfers?.map((golfer) => (
              <tr key={golfer.id}>
                <td>
              <span className="proskins-text-accent">
                {golfer.worldRanking || "Unranked"}
              </span>
                </td>
                <td>{golfer.name}</td>
                <td>
                  <button
                    className="proskins-btn proskins-btn-primary proskins-btn-small"
                    onClick={() => handleBuyPlayer(golfer.name, getTierPrice(golfer))}
                    style={{ whiteSpace: 'nowrap' }}
                  >
                    BUY ${getTierPrice(golfer)}
                  </button>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>

    </Card>
  );
};

export default GolfersList;